import { render, staticRenderFns } from "./ManageRecord.vue?vue&type=template&id=17dba6b5&scoped=true&"
import script from "./ManageRecord.vue?vue&type=script&lang=js&"
export * from "./ManageRecord.vue?vue&type=script&lang=js&"
import style0 from "./ManageRecord.vue?vue&type=style&index=0&id=17dba6b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dba6b5",
  null
  
)

export default component.exports